import ErrorMessage from '../ErrorMessage';
import Spinner from '../Spinner';
import StandalonePreview from './StandalonePreview';
import usePreviewRecommender from './usePreviewRecommender';

// The standalone preview as a hook, for the callers that want a preview element
// and nothing to configure — the recommender editor's display-configuration tab.
// The layout editor uses <TemplatePreview> instead.
const usePreview = (template) => {
  const { previewRecommender, previewError, fetchError, loading } = usePreviewRecommender(template);

  if (fetchError) {
    return <ErrorMessage message={fetchError.message} />;
  }

  if (template === null) {
    return '';
  }

  if (template === undefined || loading) {
    return <Spinner />;
  }

  if (previewError) {
    return previewError;
  }

  return <StandalonePreview recommender={previewRecommender} scope={template.scope} />;
};

export default usePreview;
